export default "__VITE_ASSET__B7FNNku6__"